/**
 * 通知中心状态管理
 *
 * @author PeterLee
 * @since 2026-03-19
 */
const state = {
   //表单校验规则
   rules: {
      //通知类型
      type:[{
         required: true,
         message: '请选择通知类型',
         trigger: 'change'
      }],
      //通知标题
      title:[{
         required: true,
         message: '请输入通知标题',
         trigger: 'blur'
      },
        {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
        }
     ],
      //通知内容
      content:[{
         required: true,
         message: '请输入通知内容',
         trigger: 'blur'
      }],
   },
   //列信息
   columnInfo: {
       //通知类型
       type:{
            visible:true,
            label:"通知类型"
       },
       //优先级
       priority:{
            visible:true,
            label:"优先级"
       },
       //业务分类
       category:{
            visible:true,
            label:"业务分类"
       },
       //通知标题
       title:{
            visible:true,
            label:"通知标题"
       },
         //发送人
         fromUserId:{
              visible:true,
              label:"发送人"
         },
        //接收人
        toUserIds:{
             visible:true,
             label:"接收人"
        },
        //发送时间
        sendTime:{
             visible:true,
             label:"发送时间"
        },
       //状态
       state:{
            visible:true,
            label:"状态"
       },
   },
   //表格数据（查询结果）
   tableData: [],
   //共有数据条数（分页控件）
   totalCount: 0,
   //选项列表（列表下拉框选择）
   options: {
       //通知类型选项
       typeOptions: [
           { label: '消息', value: 0 },
           { label: '通知', value: 1 },
           { label: '告警', value: 2 }
       ],
       //优先级选项
       priorityOptions: [
           { label: '低', value: 0 },
           { label: '中', value: 1 },
           { label: '高', value: 2 },
           { label: '紧急', value: 3 }
       ]
   },
   //查询参数
   queryParams: {
      //当前页数（分页控件）
      currPage: 1,
      //每页条数（分页控件）
      limit: 10,
      //是否升序
      ascOrder: false,
      //排序字段
      orderField: "",
      //此处为可能需要修改部分，请不要忽略
      param: {
         //通知类型
         type: undefined,
         //优先级
         priority: undefined,
         //业务分类
         category: undefined,
         //通知标题
         title: undefined,
         //状态
         state: undefined,
      }
   },
   //时间范围
   dateRange: {

   },
   //表单组件信息
   formInfo: {
      //表单组件弹出框显示控制
      dialogVisible: false,
      //是否增加操作（非增加操作会隐藏部分操作）
      isAdd: false,
      //编辑回显数据
      editData: {},
   },
   //更多按钮信息
   moreButtonProps:[
   ]
}
export default state
